import styled, { css } from 'styled-components';

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    height: auto;
    overflow: visible;
    gap: 1em;
  }
`;

export const ContainerFinished = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.5fr;
  grid-template-areas: 'left-panel content-panel';
  flex: 1;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas: 'content-panel';
    height: auto;
    min-height: auto;
    overflow: visible;
  }
`;

export const ContentFinished = styled.div`
  height: 100%;

  @media (max-width: 768px) {
    height: 100vh;
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.5fr;
  grid-template-areas: 'left-panel content-panel';
  flex: 1;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas: 'content-panel';
    height: auto;
    min-height: auto;
    overflow: visible;
  }
`;

export const LeftPanel = styled.div`
  grid-area: left-panel;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  background-color: ${({ backgroundColor }) => backgroundColor || '#0000cc'};
  min-height: 0;
  overflow: hidden;
  nav {
    ul {
      li {
        &:has(span img) {
          &::after,
          &::before {
            background-color: #008437;
          }
        }
        button {
          & > div {
            background-color: #fff;

            &:has(span img) {
              border: 1px solid #008437;
              background-color: #008437;
            }

            span {
              img {
                filter: brightness(0) invert(1);
              }
            }
          }

          span {
            small {
              font-weight: bold;
              font-family: 'Inter', sans serif;
            }
          }
        }
      }
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ContentPanel = styled.div`
  grid-area: content-panel;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-shadow: 0px 8px 6px -6px #c7c7c7;

  @media (max-width: 768px) {
    min-height: auto;
    overflow: visible;
  }
`;

export const ContentScrollArea = styled.div`
  padding: 1rem 1rem 0 1rem;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  /*background-color: #c5eaff;*/
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : '#c5eaff'};

  @media (max-width: 768px) {
    min-height: auto;
    overflow: visible;
  }
`;

export const ContentTitleScrollArea = styled.div`
  display: none;
  margin-bottom: 0.5em;
  nav {
    ul {
      li {
        &:last-child {
          button {
            & > div {
              &:has(span img) {
                border: ${(props) =>
                  props.status === 'SUCCESS' ? '#008437' : '0015C1'};
                background-color: ${(props) =>
                  props.status === 'SUCCESS' ? '#008437' : '0015C1'};
              }
            }
            span small {
              color: ${(props) =>
                props.status === 'SUCCESS' ? '#008437' : '0015C1'};
            }
          }
        }

        &:has(span img) {
          &::after,
          &::before {
            background-color: #008437;
          }
        }
        button {
          & > div {
            background-color: #fff;

            &:has(span img) {
              border: 1px solid #008437;
              background-color: #008437;
            }

            span {
              img {
                filter: brightness(0) invert(1);
              }
            }
          }

          span {
            small {
              font-weight: bold;
              font-family: 'Inter', sans serif;
            }
          }
        }
      }
    }
  }

  p {
    color: #0015c1;
    font-size: 0.4em;
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

export const ButtonContainer = styled.div`
  grid-area: buttons;
  display: flex;
  justify-content: space-between;
  padding: 1em;
  box-sizing: border-box;
  flex-wrap: wrap-reverse;

  @media (max-width: 768px) {
    padding: 1em;
    gap: 0.3em;
    max-width: 100%;
    button {
      width: 100%;
    }
  }
`;

export const ContainerProcessInterview = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: 768px) {
  }
`;

export const ContentStepper = styled.div`
  background-color: #fff;
  width: 100%;
  nav {
    ul {
      li {
        &:last-child {
          button {
            & > div {
              &:has(span img) {
                position: relative;
                border: ${(props) =>
                  props.status === 'SUCCESS' || props.status === 'PROCESSING'
                    ? '#008437'
                    : 'red'};
                background-color: ${(props) =>
                  props.status === 'SUCCESS' || props.status === 'PROCESSING'
                    ? '#008437'
                    : 'red'};

                ${(props) =>
                  props.status === 'ERROR' &&
                  css`
                    &::after {
                      content: '✕';
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: white;
                      font-size: 24px;
                      font-weight: bold;
                      z-index: 1;
                    }
                  `}
              }
            }
            span small {
              color: ${(props) =>
                props.status === 'SUCCESS' || props.status === 'PROCESSING'
                  ? '#008437'
                  : 'red'};
            }
          }
        }

        &:has(span img) {
          &::after,
          &::before {
            background-color: #008437;
          }
        }
        button {
          & > div {
            background-color: #fff;

            &:has(span img) {
              border: 1px solid #008437;
              background-color: #008437;
            }

            span {
              img {
                filter: brightness(0) invert(1);
              }
            }
          }

          span {
            small {
              font-weight: bold;
              font-family: 'Inter', sans serif;
            }
          }
        }
      }
    }
  }
  padding: 1em;
  @media (max-width: 768px) {
  }
`;

export const HeaderResult = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ContentResultProcess = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  padding: 1em 1em 0 1em;
  background-color: ${({ bgColor }) => bgColor || 'blue'};
  background-image: ${({ bgImage }) => (bgImage ? `url(${bgImage})` : 'none')};
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
  flex: 1;

  @media (max-width: 768px) {
  }
`;

export const ContainerResults = styled.div`
  padding: 1em;
  background-color: ${({ bgColor }) => bgColor || 'blue'};

  @media (max-width: 768px) {
  }
`;

export const ContentImg = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
  }
`;
